export default __webpack_public_path__ + "static/media/ritual1.e37376e1.png";